import { inject, Injectable } from '@angular/core';
import {
  GET_JOB_REF_ID_BY_SMART_CONTRACT_ID_QUERY,
  GetJobRefIdBySmartContractIdResponse,
} from '@control-tower/queries/get-job-ref-id-by-smart-contract-id.query';
import {
  GET_PARENT_CONTROL_TOWER_ID_AND_CONTRACT_PARTIES_BY_CONTROL_TOWER_ID,
  GetParentControlTowerIdAndContractPartiesByControlTowerIdResponse,
} from '@control-tower/queries/get-parent-control-tower-id-and-contract-parties-by-control-tower-id.query';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ControlTowerSmartContractService {
  private readonly apollo = inject(Apollo);

  fetchParentControlTowerIdAndContractPartiesByControlTowerId(controlTowerId: string) {
    return this.apollo
      .query<GetParentControlTowerIdAndContractPartiesByControlTowerIdResponse>({
        query: GET_PARENT_CONTROL_TOWER_ID_AND_CONTRACT_PARTIES_BY_CONTROL_TOWER_ID,
        variables: { controlTowerId },
      })
      .pipe(map(res => res.data.contract));
  }

  fetchJobRefIdBySmartContractId(smartContractId: string) {
    return this.apollo
      .query<GetJobRefIdBySmartContractIdResponse>({
        query: GET_JOB_REF_ID_BY_SMART_CONTRACT_ID_QUERY,
        variables: { smartContractId },
      })
      .pipe(map(res => res.data.getJobRefIdBySmartContractId));
  }
}
